module.exports = __webpack_public_path__ + "a8a10a3e/img/document.e2130c6b.svg";